import CardsList from 'components/card/CardsList';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import React, { useState } from 'react';
import { PuckDewarContainerView } from '../puck/constants';
import { Dewar, DewarCardTemplateProps } from './cardTemplates';
import { useAttachSidePanelBackButton } from './hooks';
import { CrystalDataDTO } from '../constants';
import {
  getCrystalsByPuckId,
  getCrystalById,
  getDewarSlotAvailable,
  getPuckIdsOfDewar,
  getUpdatedCrystalsAfterCrystalContainerAssignments,
} from './utils';
import { useAllDewars, useAllPucks, useSelectedCrystalId } from 'redux/hooks/synchrotron';
import { setIsCrystalAssignmentsDirty } from 'redux/reducers/synchrotronTripReducer';
import { useRMDispatch } from 'redux/hooks';
import RMModal from 'components/modal/RMModal';
import { ModalDetails } from 'business/models/CustomModels';
interface Props extends WithTabBackButtonStateProps {
  setContentView?: (contentView: PuckDewarContainerView) => void;
  crystals: CrystalDataDTO[];
  setCrystals: React.Dispatch<React.SetStateAction<CrystalDataDTO[]>>;
}
const SelectDewar = (props: Props) => {
  const { setContentView, crystals, setCrystals, setHandleOnTabBackPress } = props;

  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    onCancel: () => {},
    body: 'A Dewar is already assigned to current puck and is referenced by more than one crystal, changing this assignment will update dewar of all crystal having same puck. Are you sure you want to continue?',
    heading: 'Warning',
    isOkOnly: false,
    okButtonText: 'Proceed',
    noButtonText: 'Cancel',
    showButtons: true,
  });
  const selectedCrystalId = useSelectedCrystalId();
  const selectedCrystal = getCrystalById(crystals, selectedCrystalId);
  const dispatch = useRMDispatch();
  const dewars = useAllDewars();
  const pucks = useAllPucks();
  const dewarCards: Array<DewarCardTemplateProps> = dewars.map((dewar) => {
    const pucksOfSelectedDewar = getPuckIdsOfDewar(crystals, dewar.id);
    const slotAvailable = getDewarSlotAvailable(
      dewar,
      pucksOfSelectedDewar,
      pucks,
      crystals,
      selectedCrystal?.crystalContainerAssignments?.puckId,
    );
    return {
      name: dewar.name,
      puckCount: dewar.puckCount,
      slotAvailable: slotAvailable,
      onDewarCardClickHandler: () => {
        dewarSelectHandler(dewar);
      },
    };
  });

  const discardDewarAssignment = () => {
    setContentView(PuckDewarContainerView.PuckDewarInfoView);
    setHandleOnTabBackPress(null);
  };
  const assignDewarToCrystals = (selectedDewar) => {
    const updatedCrystals = getUpdatedCrystalsAfterCrystalContainerAssignments(
      crystals,
      selectedCrystalId,
      {
        dewarId: selectedDewar.id,
        isDirty: true,
      },
    );
    setCrystals(updatedCrystals);
    setContentView(PuckDewarContainerView.PuckDewarInfoView);
    setHandleOnTabBackPress(null);
    dispatch(setIsCrystalAssignmentsDirty(true));
  };
  const dewarSelectHandler = (selectedDewar) => {
    const { puckId: selectedPuckId, dewarId: oldDewarId } =
      selectedCrystal.crystalContainerAssignments;
    const allCrystalsAssignedToSelectedPuck = getCrystalsByPuckId(
      crystals,
      selectedPuckId,
    );
    if (
      oldDewarId &&
      oldDewarId !== selectedDewar.id &&
      allCrystalsAssignedToSelectedPuck.length > 1
    ) {
      setModalDetails({
        ...modalDetails,
        showModal: true,
        setShowModal: discardDewarAssignment,
        onOk: () => {
          assignDewarToCrystals(selectedDewar);
        },
        onCancel: discardDewarAssignment,
      });
    } else {
      assignDewarToCrystals(selectedDewar);
    }
  };

  useAttachSidePanelBackButton(
    setHandleOnTabBackPress,
    setContentView,
    PuckDewarContainerView.PuckDewarInfoView,
  );
  return (
    <div
      id="puckdewarcontainer-selectdewar-wrapper"
      className="flex flex-col w-full h-full pb-2"
    >
      <RMModal id="puckdewarcontainer-selectdewar-modal" {...modalDetails} />
      <CardsList cardContent={dewarCards} cardTemplate={Dewar} />
    </div>
  );
};
export default withTabBackButton(SelectDewar);
